import { betriebsmeldungenApi } from "@/config/httpClient"
import { Betriebsmeldung } from "@/generated/openapi"

class BetriebsmitteilungenService {

  public getBetriebsmitteilungen(): Promise<Betriebsmeldung[]> {
    return betriebsmeldungenApi.betriebsmeldungen()
      .then(resp => resp.data)
      .then(data => {
        if (!Array.isArray(data)) {
          throw new Error("invalid JSON")
        }
        return data
      })
  }
}

const betriebsmitteilungenService = new BetriebsmitteilungenService()
export default betriebsmitteilungenService
